import { storeToRefs } from 'pinia';
import { useAuth } from "@/stores/AuthStore";

export const reconciliationAccessGuard = (to, from, next) => {
    const { isAdmin, isSuperAdmin, organization } = storeToRefs(useAuth());

    if (organization.value?.reconciliation_enabled && (isAdmin.value || isSuperAdmin.value)) {
        return next();
    }

    return next('access-denied');
};
